export const CardStats = ({ item, index }) => {
  const { stat_title, stat_count, icon_url } = item;

  return (
    <div
      key={index}
      className="d-flex flex-column fw-semibold justify-content-between align-items-start"
      style={{
        width: "22%",
        height: "80px",
      }}
    >
      <div className="row">
        <div className="col">
          <img src={icon_url} className="w-auto" alt="icon" />
        </div>
        <div className="col d-flex justify-content-center align-items-center">
          <h2
            className="fw-bolder fs-1"
            style={{
              color: "#E45B0D",
            }}
          >
            {stat_count}
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <p>{stat_title}</p>
        </div>
      </div>
    </div>
  );
};
